import axios from "@/api/axiosInstance";
import {
  FetchTrainingHistoryReportParams,
  FetchTrainingHistoryReportResponse,
} from "./types";

export const fetchTrainingHistoryReport = async (
  params: FetchTrainingHistoryReportParams = {},
): Promise<FetchTrainingHistoryReportResponse> => {
  const response = await axios.get<FetchTrainingHistoryReportResponse>(
    "/api/private/reports/training-history",
    { params },
  );
  return response.data;
};
